import React, { FC } from 'react'
import { Controller, useForm } from 'react-hook-form'

import BootstrapModalLayout from '../../../ui/BootstrapModalLayout'
import { Combobox } from '../../../common/components/combobox'
import { usePartnerGetCompaniesByPartnerIdQuery } from '../../../common/redux/api/web-api'
import useText from '../../../common/hooks/useText'

export type AddRFIDModalProps = {
    onClose: () => void
    onSubmit: (organisationId: string) => void
    partnerId: number
}

export const AddRFIDModal: FC<AddRFIDModalProps> = ({ onClose, onSubmit, partnerId }) => {
    const text = useText()
    const { data: organisations = [], isLoading } = usePartnerGetCompaniesByPartnerIdQuery({ partnerId })

    const {
        handleSubmit,
        control: organisationControl,
        formState: { isDirty },
    } = useForm<{ organisationId: string }>({
        mode: 'all',
    })

    return (
        <BootstrapModalLayout
            title={text('lblAddRFIDTagsModal')}
            actions={[
                {
                    label: text('btnCancel'),
                    callback: onClose,
                    btn: 'btn-secondary',
                },
                {
                    label: text('btnSave'),
                    callback: handleSubmit(({ organisationId }) => onSubmit(organisationId)),
                    disabled: !isDirty,
                    loading: isLoading,
                },
            ]}
        >
            <Controller
                name="organisationId"
                control={organisationControl}
                render={({ field: { value, onChange, ...rest } }) => (
                    <Combobox
                        id="select-organisation"
                        wrapperClassName="mb-8 mt-4"
                        enableDefaultOption={false}
                        labelText={`${text('lblOrganisationField')} *`}
                        value={value}
                        options={organisations?.map((organisation) => ({
                            value: organisation?.id,
                            label: organisation?.name || '',
                        }))}
                        onChange={(option) => onChange(option.value)}
                        {...rest}
                    />
                )}
            />
        </BootstrapModalLayout>
    )
}
